/**
 * Type definitions for Product Catalog Management
 */

export enum ProductCatalogStatus {
    Trial = 'Trial',
    Production = 'Production',
    Inactive = 'Inactive',
}

export const PRODUCT_CATALOG_STATUS_OPTIONS = [
    { value: ProductCatalogStatus.Production, label: 'Production' },
    { value: ProductCatalogStatus.Trial, label: 'Trial' },
    { value: ProductCatalogStatus.Inactive, label: 'Inactive' },
] as const;

export interface ProductCatalog {
    ProductSKU: string;
    ProductName: string;
    ProductLine: string;
    InvoiceName: string;
    ShortCode: string;
    CutProfile: number | null;
    CutProfileSKU: string | null;
    SuccessCutSKU: string;
    WarrantyCutSKU: string;
    CutPlanID: number;
    SheetID: number;
    SortOrder: number;
    JobName: string;
    Status: ProductCatalogStatus;
}

export interface ProductOption {
    ProductSKU: string;
    ProductName: string;
    ProductLine: string;
    InvoiceName: string;
    CutProfile: number | null;
    CutProfileSKU: string | null;
    CutPlanID: number;
    SheetID: number;
    SheetName: string;
    JobName: string;
}

export interface SKUOption {
    SKU: string;
    Name: string;
}

export interface SKUsByPlan {
    prepaid: SKUOption[];
    postpaid: SKUOption[];
}

export interface BusinessCentralProducts {
    products: ProductOption[];
    successSKUs: SKUsByPlan;
    warrantySKUs: SKUsByPlan;
}

export interface ProductCatalogListResponse {
    productCatalogs: ProductCatalog[];
}

export interface ProductCatalogRequest {
    ProductSKU: string;
    ProductName: string;
    ProductLine: string;
    InvoiceName: string;
    ShortCode: string;
    CutProfile: number | null;
    CutProfileSKU: string | null;
    SuccessCutSKU: string;
    WarrantyCutSKU: string;
    CutPlanID: number;
    SheetID: number;
    SortOrder?: number;
    JobName: string;
    Status: ProductCatalogStatus;
}

export interface ProductCatalogOrderRequest {
    orders: { ProductSKU: string; SortOrder: number }[];
}
